import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import ArticlesSection from "./components/ArticlesSection";
import ColumnsSection from "./components/ColumnsSection";
import RamblingsSection from "./components/RamblingsSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import ScrollTopButton from "./components/ScrollTopButton";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <HotTopics />
        <ArticlesSection />
        <ColumnsSection />
        <RamblingsSection />
        <AboutSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <ScrollTopButton />
    </div>
  );
}